import { GALLERY } from "../data/eventData";
import { MaskLine } from "./Motion";

// Mosaico em L invertido · texto no canto superior esquerdo, fotos contornam à direita e por baixo
// Desktop: grade de 6 colunas · Mobile: 2 colunas uniformes
const PHOTO_SPANS = [
  "sm:col-span-3",              // 1 · ao lado do texto (topo direito)
  "sm:col-span-3",              // 2 · ao lado do texto
  "sm:col-span-2",              // 3 · abaixo do texto
  "sm:col-span-2",              // 4
  "sm:col-span-2",              // 5
  "sm:col-span-3",              // 6
  "sm:col-span-3",              // 7
];

export default function GallerySlider() {
  return (
    <section id="galeria" className="relative py-20 sm:py-28 overflow-hidden" data-testid="gallery-section">
      <div className="absolute inset-0 bg-[radial-gradient(900px_520px_at_20%_30%,rgba(0,142,255,0.10),transparent_65%)] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div
          className="grid grid-cols-2 sm:grid-cols-6 auto-rows-[130px] sm:auto-rows-[155px] lg:auto-rows-[175px] gap-3 [grid-auto-flow:dense]"
          data-testid="gallery-mosaic"
        >
          {/* Célula de texto · canto superior esquerdo (contornada pelas fotos) */}
          <div className="col-span-2 sm:col-span-3 sm:row-span-2 flex flex-col justify-center pr-2 sm:pr-10 py-4">
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-[-0.02em]" data-testid="gallery-heading">
              <MaskLine inView>Quem vive o Summit,</MaskLine>
              <MaskLine inView delay={0.12}>
                <span className="text-gradient-blue">nunca mais é o mesmo.</span>
              </MaskLine>
            </h2>
          </div>

          {/* Fotos do mosaico */}
          {GALLERY.map((src, i) => (
            <div
              key={i}
              className={`group relative rounded-xl overflow-hidden border border-white/10 transition-colors duration-500 hover:border-white/30 ${PHOTO_SPANS[i] || ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={src}
                alt={`Edição anterior do Pregoeiros Summit · foto ${i + 1}`}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transform-gpu transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.07] group-hover:saturate-[1.15] group-hover:brightness-110"
                draggable={false}
              />
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-brand-base/60 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <div className="absolute inset-0 pointer-events-none bg-white/0 transition-colors duration-500 group-hover:bg-white/10" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
